import { cacheCart } from '../cartApi';

export const calcBogoBonusProducts = (bogoMeta) => {
  if (
    !bogoMeta ||
    !bogoMeta.is_active ||
    !Array.isArray(bogoMeta.bonus_products) ||
    !bogoMeta.bonus_products.length > 0
  ) {
    return null;
  }

  const cartItems = cacheCart()?.items || [];

  return bogoMeta.bonus_products
    .map(({ id, available }, index) => {
      const quantityBonusVariantsInCart =
        cartItems.find((lineItem) => Number(lineItem.id) === Number(id))
          ?.quantity || 0;

      if (
        available &&
        quantityBonusVariantsInCart >=
          bogoMeta.max_quantities_bonus_products[index]
      ) {
        return null;
      }

      return {
        id: Number(id),
        quantity: bogoMeta.quantities_bonus_products[index] || 1,
      };
    })
    .filter(Boolean);
};
